import React, { useState } from 'react';
import classes from '../pages.module.css';
import { Container } from "react-bootstrap";
import TextCol from "../../components/Ui/text/textCol";
import BtnDownload from '../../components/Ui/button/btnDownload';
import ModuleItem from '../../components/Ui/block/moduleItem';
import agregator from '../../image/modules/aggregator3.png';

const Ags20 = () => {
    const [texts, settexts] = useState([
        {id:1, content: 'Полностью гибкая архитектура с множеством вариантов'},
        {id:2, content: 'Несколько PoE для поддержки и объединения всех внешних радиостанций'},
        {id:3, content: 'Гибкое управление очередью планировщика'},
        {id:4, content: 'Поддержка трафика TDM Native и Circuit Emulated PWE3'},
        {id:5, content: 'Несколько портов Ethernet 10 Гбит/с'},
        {id:6, content: 'Поддержка QoS и HQoS на основе: VLAN, IPv4, IPv6, Биты exp MPLS'},
    ])
    const [lists, setlists] = useState ([])
    return(
        <>
            <div className={classes.topBox}>
                <Container fluid="md">
                    <div className={classes.topboxBody}>
                        <span>радиорелейное оборудование</span>
                        <h1>AGS20</h1>
                        <p>Уникальная единая универсальная платформа, предназначенная для агрегации новых сетевых сервисов, связанных с появлением LTE-A, конвергенцией мобильной и фиксированной связи и подготовкой к запуску 5G инфраструктуры транспортной сети. Это универсальная платформа, удовлетворяющая потребностям в мульти-технологической агрегации трафика операторского класса, специально разработанной для нужд мобильной транспортной сети.</p>
                    </div>
                </Container>
                <div className={classes.topBg_small}></div>
            </div>
            <TextCol texts={texts} />
            <BtnDownload title="Скачать спецификацию" url='/src/download/test.txt' />
            <ModuleItem item={{
                class: 'moduleItem1',
                title: 'AGS20',
                body: 'AGS20 - это внутренний блок следующего поколения для радиоприемников с раздельным монтажом, способный работать как с традиционным раздельным креплением с несколькими радио модулями ПЧ, так и использоваться для объединения нескольких блоков внешнего исполнения или сочетания этих решений. Внутренний блок имеет различные варианты аппаратного обеспечения от самых компактных решений до модульных полностью резервированных и легко масштабируемых блоков. Имея на борту коммутатор высокой емкости и несколько портов 10GbE, функционал обработки пакетов MEF2.0 и IP / MPLS, c распределением частоты и фазы в пакетной сети, AGS20 подходит для наиболее загруженных сайтов и тяжелых условий эксплуатации/',
                src: (agregator),

            }}
                lists={lists}
            />
        </>
    )
}

export default Ags20;